import styles from './SimService.module.css'
import sim from '../Img/simLogo.png'
import MainFormTemplate from "../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../FormTemplate/InputItem/InputItem";
import React, {useEffect, useRef, useState} from "react";
import ErrorLineItem, {ErrorLineItemRef} from "../FormTemplate/ErrorLineItem/ErrorLineItem";
import useApiQuery from "../ApiQuery/UseApiQuery";
import WaitLoader from "../WaitLoader/WaitLoader";
import useLongTask from "../Util/LongTaskItem/UseLongTask";

interface IXLine
{
    tag:string
    text: string
    style?:string
}
interface IYLine
{
    text: string
    style?:string
}
interface ISimInfo
{
    xLine: IXLine[],
    yLine: IYLine[],
    payment: {
        amount:number
        realAmount:number
        use:boolean
        orderId:string
    }
}

declare global {
    interface Window {
        Telegram: any;
        WebApp: any;
    }
}
export default function SimService(){
    const [ctn,setCtn] = useState("")
    const [validCtn, setValidCtn] = useState(false)
    const stateRef = useRef<ErrorLineItemRef>(null)

    const [mode, setMode] = useState(0)
    const dataSimInfo = useRef<{
        ctn: string
    }>(null)
    const [ldrSimInfo,rsSimInfo,exSimInfo] = useApiQuery("/core/tg/sim/info","post",dataSimInfo);

    const screenY = window.innerHeight
    const screenX = window.innerWidth
    const [simInfo, setSimInfo] = useState<ISimInfo>()
    const [showPayFrame, setShowPayFrame] = useState(false)

    const [showGoodPage, setShowGoodPage] = useState(false)

    const [frameLoaded, setFrameLoaded] = useState(false)
    const refDiv = useRef<HTMLDivElement>(null)

    const [work, setWork] = useState(false)

    const [payData, setPayData] = useState<{
        url:string
        rayId:string
    }>()




    const dataStopCheckTask = useRef<{
        rayId: string
    }>(null)
    const [ldrStopCheckTask,rsStopCheckTask,exStopCheckTask] = useApiQuery("/payment/state/task/stop","post",dataStopCheckTask);



    const dataCheckPay = useRef<{
        orderId: string
    }>(null)
    const [ldrCheckPay,rsCheckPay,exCheckPay] = useApiQuery("/payment/state/task","post",dataCheckPay);
    const [ldrCheckPayTask, exCheckPayTask,stCheckPayTask] = useLongTask(100,1500, (state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),(state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),false)
    const onResultTaskTick = (state: boolean, data:any , code:number ,cnt: number)=>{
        console.log("tick",state,data)
        if(state)
        {
            if(data?.state)
            {
                //Платеж прошел
                setShowPayFrame(false)
                setPayData(undefined)
                if(simInfo)setSimInfo({...simInfo,payment: {...simInfo?.payment,use: false}})
                // if(simInfo)setSimInfo({...simInfo,payment: undefined})
                setShowGoodPage(true)
                setTimeout(()=>setShowGoodPage(false), 7000)

                //if(stateRef.current)stateRef.current.show("Платеж прошел, средства поступят на счет в течение 30 минут",false,10000)
                return
            }
        }

    }


    useEffect(() => {
        // Проверяем, доступен ли объект Telegram Web App
        if (window.Telegram && window.Telegram.WebApp) {
            // Инициализируем Telegram Web App
            window.Telegram.WebApp.ready();

            // Получаем initData
            const initData = window?.Telegram?.WebApp.initData;

            // Парсим данные пользователя
            const user = parseInitData(initData);
            //setUserData(user);
        } else {
            console.error('Telegram Web App is not available');
        }
    }, []);

    useEffect(()=>{
        if(simInfo)setMode(1)
        console.log(simInfo)
    },[simInfo])



    const parseInitData = (initData: string) => {
        const params = new URLSearchParams(initData);
        return {
            user: params.get('user'),
            hash: params.get('hash'),
            auth_date: params.get('auth_date'),
            start_param: params.get('start_param'),
            chat_type: params.get('chat_type'),
            chat_instance: params.get('chat_instance'),
        };
    };
    const handleSimInfo=()=>{
        dataSimInfo.current ={
            ctn: ctn.slice(-10)
        }
        setMode(0)
        setWork(true)
        exSimInfo().then((e)=>{
            setWork(false)
            if(e?.success)
            {
                console.log(e?.payload)
                setSimInfo(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера, свяжитесь по номеру +79993046060",true,4000)
        })
    }


    const buildSimInfoXLine = () =>{
        const x = simInfo?.xLine?.map((item,idx)=>{
            let type =''
            if(item?.style?.match(/r/ui))type+=(' ' + styles.cRed)
            if(item?.style?.match(/b/ui))type+=(' ' + styles.cBlue)
            return(
                <div className={styles.xLineCont} key={idx}>
                    <div className={styles.xLineTag}> {item?.tag}</div>
                    <div className={[styles.xLineText, type].join(' ')}>{item?.text}</div>
                </div>
            )
        })
        return x
    }

    const buildSimInfoYLine = () =>{
        const x = simInfo?.yLine?.map((item,idx)=> {
            let type = ''
            if (item?.style?.match(/r/ui)) type += (' ' + styles.cRed)
            if (item?.style?.match(/b/ui)) type += (' ' + styles.cBlue)
            return(
                <div className={[styles.yLineText, type].join(' ')} key={idx}>{item?.text}</div>
            )
        })
        return x
    }

    const buildSimInfo = () =>{
        if(! simInfo) return null
        if(mode !==1 ) return null
        return (
            <>
                <div className={styles.simInfoCont}>
                    {buildSimInfoXLine()}
                </div>
                <div className={styles.simInfoCont}>
                    {buildSimInfoYLine()}
                </div>
            </>
        )
    }

    const buildPayFrame = () =>{
        if(!showPayFrame) return null
        if(!payData?.url)return null
        const fW = Math.floor(screenX * 0.9)
        const fH = refDiv?.current ? refDiv.current.clientHeight -20 : Math.floor(screenX * 0.9)

        const fWidth = fW>500 ? 500 : fW
        const fHeight = fH>800 ? 800 :fH
        return (
            <div className={styles.payCont}>
                {!frameLoaded &&
                    <div className={styles.frameLoader}>
                        <WaitLoader loading={true} api={rsSimInfo} onlyLoading={true}>

                        </WaitLoader>
                    </div>

                }
                <iframe
                    src={payData?.url}
                    style={{width:`${fWidth}px`,height:`${fHeight}px`}}
                    onLoad={()=>{
                        setFrameLoaded(true)
                        setWork(false)
                    }}


                ></iframe>
                {frameLoaded &&
                    <div
                        onClick={handleCancelPay}
                        className={styles.payClose}
                    >
                        Отменить
                    </div>

                }
            </div>

        )

    }

    async function handleStartPay(){
        if(work)return
        if(!simInfo?.payment?.orderId) {
            if(stateRef.current)stateRef.current.show("Нет информации о заказе",true,2000)
            return
        }

        dataCheckPay.current = {
            orderId: simInfo?.payment?.orderId
        }
        exCheckPay().then((e)=>{
            if(e?.success)
            {
                setShowPayFrame(true)
                setWork(true)
                setFrameLoaded(false)
                setPayData(e?.payload)
                exCheckPayTask(e?.payload?.rayId)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера, свяжитесь по номеру +79993046060",true,4000)
        })


    }
    const handleCancelPay = () =>{
        setShowPayFrame(false)
        setWork(false)
        stCheckPayTask()
        if(payData)
        {
            dataStopCheckTask.current={
                rayId: payData?.rayId
            }
            console.log("stop task")
            exStopCheckTask().then((e)=>console.log(e))

        }


    }

    const buildPayment = ()=>{
        if( !simInfo?.payment?.use) return null
        const discount = simInfo?.payment?.realAmount - simInfo?.payment?.amount
        return (
            <div className={styles.pmCont}
                onClick={handleStartPay}
            >
                <div className={styles.pmButt}>
                    <div>Оплатить {simInfo?.payment?.amount} руб.</div>
                    <div className={styles.pbButtLine1}>скидка <span>{discount}</span> руб.</div>

                </div>

            </div>
        )
    }

    const buildGoodFrame = () =>{
        if(!showGoodPage) return null
        if(showPayFrame) return null
        return (
            <div className={styles.goodCont}>
                Платеж принят, средства поступят на счет в течение 30 минут
            </div>
        )
    }

    return(
        <div className={styles.mainCont}>
            <div className={styles.itemCont} ref={refDiv}>
                {buildPayFrame()}
                {buildGoodFrame()}
                <MainFormTemplate maxWidth={"100%"} title={""}>
                    <div className={styles.simImgCont}>
                        <img src={sim} className={styles.simImg}></img>
                    </div>
                    <div className={styles.ctnTitle}>Введите Ваш номер</div>
                    <div className={styles.ldrCont}>
                        <div className={styles.ldrUnit}>
                            <WaitLoader loading={ldrSimInfo } api={rsSimInfo} onlyLoading={true}>

                            </WaitLoader>

                        </div>
                        <InputItem
                            mode={"ei"}
                            val={ctn}
                            title={"номер"}
                            info={"Номер указан на пластике, только цифры"}
                            regExp={/(8|\+7|^)9[0-9]{9}$/ui}
                            type={"numeric"}
                            maxLen={12}

                            onChange={(e)=>{
                                if(e?.match(/(8|\+7|^)9[0-9]{9}$/ui)){
                                    setCtn("+7"+e?.slice(-10))
                                    setValidCtn(true)
                                    return
                                }
                                setValidCtn(false)
                                setCtn(e)
                            }}

                        />

                    </div>
                    {buildSimInfo()}
                    {buildPayment()}

                    <div className={styles.stateCont}>
                        <ErrorLineItem ref={stateRef}></ErrorLineItem>

                    </div>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                disabled={!validCtn || work}
                                onClick={handleSimInfo}
                        >Информация</button>


                    </div>

                </MainFormTemplate>
            </div>
        </div>
    )
}